<template>
  <ProductTitle
    v-bind="{
      productName,
      productExclusiveName,
      description,
      pdfEmailDescription,
      brandUrl: isSTC ? undefined : brandUrl,
      brandDisplayName: isSTC || !showBrandName ? '' : brandDisplayName,
      productUrl,
      allowOpeningInNewTab,
      ...(showBrandLink && !isSTC ? { brandName } : {}),
    }"
    @click="$emit('click', $event)"
  />
</template>

<script setup>
import { computed, inject } from 'vue';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import useConsolidatedProductDetails from '~/composables/useConsolidatedProductDetails';
import ProductTitle from './ProductTitle.vue';

const isSTC = inject('isSTC', false);

defineEmits(['click']);

defineProps({
  productUrl: {
    type: String,
    default: '',
  },
  showBrandLink: {
    type: Boolean,
    required: false,
    default: true,
  },
  showBrandName: {
    type: Boolean,
    required: false,
    default: true,
  },
  allowOpeningInNewTab: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { productName: consolidatedName, productExclusiveName: consolidatedExclusiveName } = useConsolidatedProductDetails();
const {
  productName: nameRaw,
  productExclusiveName: exclusiveNameRaw,
  brandName,
  brandDisplayName,
  brandUrl: brandUrlRaw,
  secondaryDescription: description,
  pdfEmailDescription,
} = useCommonProductGetters();

const productName = computed(() => consolidatedName.value || toValue(nameRaw));
const productExclusiveName = computed(() => consolidatedExclusiveName.value || toValue(exclusiveNameRaw));

const brandUrl = toValue(brandDisplayName) && toValue(brandUrlRaw);

defineExpose({
  brandName,
  brandUrl,
  productName,
  description,
  pdfEmailDescription,
});
</script>
